// extracted by mini-css-extract-plugin
export default {"fab":"MobileGiveBar_fab__bwq3I"};